
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#paperclip_svg__clip0_2969_73130)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.073 3.052a3.174 3.174 0 00-4.49 0L3.99 9.646a4.5 4.5 0 006.364 6.364l5.086-5.086a.5.5 0 11.707.707l-5.086 5.087a5.5 5.5 0 11-7.779-7.779l6.595-6.594a4.174 4.174 0 115.903 5.903l-6.728 6.729a2.81 2.81 0 01-3.975-3.975l7.205-7.205a.5.5 0 11.707.707l-7.205 7.205a1.81 1.81 0 002.56 2.56l6.729-6.728a3.174 3.174 0 000-4.489z"}})])])
          )
        }
      }
    